/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Builder_Max_Steps_SummaryInputs */



/**
* | output |
* | --- |
* | "up to {count} steps" |
*
* @param {Agent_Builder_Max_Steps_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_summary = /** @type {((inputs: Agent_Builder_Max_Steps_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`bis zu ${i?.count} Schritte`)
	return /** @type {LocalizedString} */ (`up to ${i?.count} steps`)
});